export default {
  AED: {
    code: '784',
    title: 'United Arab Emirates dirham	 United Arab Emirates',
  },
  AFN: { code: '971', title: 'Afghan afghani	 Afghanistan' },
  ALL: { code: '008', title: 'Albanian lek	 Albania' },
  AMD: { code: '051', title: 'Armenian dram	 Armenia' },
  ANG: {
    code: '532',
    title: 'Netherlands Antillean guilder	 Curaçao (CW),  Sint Maarten (SX)',
  },
  AOA: { code: '973', title: 'Angolan kwanza	 Angola' },
  ARS: { code: '032', title: 'Argentine peso	 Argentina' },
  AUD: {
    code: '036',
    title:
      'Australian dollar	 Australia,  Christmas Island (CX),  Cocos (Keeling) Islands (CC),  Heard Island and McDonald Islands (HM),  Kiribati (KI),  Nauru (NR),  Norfolk Island (NF),  Tuvalu (TV)',
  },
  AWG: { code: '533', title: 'Aruban florin	 Aruba' },
  AZN: { code: '944', title: 'Azerbaijani manat	 Azerbaijan' },
  BAM: {
    code: '977',
    title: 'Bosnia and Herzegovina convertible mark	 Bosnia and Herzegovina',
  },
  BBD: { code: '052', title: 'Barbados dollar	 Barbados' },
  BDT: { code: '050', title: 'Bangladeshi taka	 Bangladesh' },
  BGN: { code: '975', title: 'Bulgarian lev	 Bulgaria' },
  BHD: { code: '048', title: 'Bahraini dinar	 Bahrain' },
  BIF: { code: '108', title: 'Burundian franc	 Burundi' },
  BMD: { code: '060', title: 'Bermudian dollar	 Bermuda' },
  BND: { code: '096', title: 'Brunei dollar	 Brunei' },
  BOB: { code: '068', title: 'Boliviano	 Bolivia' },
  BOV: { code: '984', title: 'Bolivian Mvdol (funds code)	 Bolivia' },
  BRL: { code: '986', title: 'Brazilian real	 Brazil' },
  BSD: { code: '044', title: 'Bahamian dollar	 Bahamas' },
  BTN: { code: '064', title: 'Bhutanese ngultrum	 Bhutan' },
  BWP: { code: '072', title: 'Botswana pula	 Botswana' },
  BYN: { code: '933', title: 'Belarusian ruble	 Belarus' },
  BZD: { code: '084', title: 'Belize dollar	 Belize' },
  CAD: { code: '124', title: 'Canadian dollar	 Canada' },
  CDF: {
    code: '976',
    title: 'Congolese franc	 Democratic Republic of the Congo',
  },
  CHE: { code: '947', title: 'WIR Euro (complementary currency)	  Switzerland' },
  CHF: { code: '756', title: 'Swiss franc	  Switzerland,  Liechtenstein (LI)' },
  CHW: {
    code: '948',
    title: 'WIR Franc (complementary currency)	  Switzerland',
  },
  CLF: { code: '990', title: 'Unidad de Fomento (funds code)	 Chile' },
  CLP: { code: '152', title: 'Chilean peso	 Chile' },
  CNY: { code: '156', title: 'Renminbi (Chinese) yuan[8]	 China' },
  COP: { code: '170', title: 'Colombian peso	 Colombia' },
  COU: {
    code: '970',
    title: '9]	Unidad de Valor Real (UVR) (funds code)[9]	 Colombia',
  },
  CRC: { code: '188', title: 'Costa Rican colon	 Costa Rica' },
  CUC: { code: '931', title: 'Cuban convertible peso	 Cuba' },
  CUP: { code: '192', title: 'Cuban peso	 Cuba' },
  CVE: { code: '132', title: 'Cape Verde escudo	 Cape Verde' },
  CZK: { code: '203', title: 'Czech koruna	 Czechia [10]' },
  DJF: { code: '262', title: 'Djiboutian franc	 Djibouti' },
  DKK: {
    code: '208',
    title: 'Danish krone	 Denmark,  Faroe Islands (FO),  Greenland (GL)',
  },
  DOP: { code: '214', title: 'Dominican peso	 Dominican Republic' },
  DZD: { code: '012', title: 'Algerian dinar	 Algeria' },
  EGP: { code: '818', title: 'Egyptian pound	 Egypt' },
  ERN: { code: '232', title: 'Eritrean nakfa	 Eritrea' },
  ETB: { code: '230', title: 'Ethiopian birr	 Ethiopia' },
  EUR: {
    code: '978',
    title:
      'Euro	 Andorra (AD),  Austria (AT),  Belgium (BE),  Cyprus (CY),  Estonia (EE),  Finland (FI),  France (FR),  Germany (DE),  Greece (GR),  Guadeloupe (GP),  Ireland (IE),  Italy (IT),  Latvia (LV),  Lithuania (LT),  Luxembourg (LU),  Malta (MT),  Martinique (MQ),  Mayotte (YT),  Monaco (MC),  Montenegro (ME),  Netherlands (NL),  Portugal (PT),  Réunion (RE),  Saint Barthélemy (BL),  Saint Pierre and Miquelon (PM),  San Marino (SM),  Slovakia (SK),  Slovenia (SI),  Spain (ES)',
  },
  FJD: { code: '242', title: 'Fiji dollar	 Fiji' },
  FKP: {
    code: '238',
    title: 'Falkland Islands pound	 Falkland Islands (pegged to GBP 1:1)',
  },
  GBP: {
    code: '826',
    title:
      'Pound sterling	 United Kingdom, the  Isle of Man (IM, see Manx pound),  Jersey (JE, see Jersey pound), and  Guernsey (GG, see Guernsey pound)',
  },
  GEL: { code: '981', title: 'Georgian lari	 Georgia' },
  GHS: { code: '936', title: 'Ghanaian cedi	 Ghana' },
  GIP: { code: '292', title: 'Gibraltar pound	 Gibraltar (pegged to GBP 1:1)' },
  GMD: { code: '270', title: 'Gambian dalasi	 Gambia' },
  GNF: { code: '324', title: 'Guinean franc	 Guinea' },
  GTQ: { code: '320', title: 'Guatemalan quetzal	 Guatemala' },
  GYD: { code: '328', title: 'Guyanese dollar	 Guyana' },
  HKD: { code: '344', title: 'Hong Kong dollar	 Hong Kong' },
  HNL: { code: '340', title: 'Honduran lempira	 Honduras' },
  HRK: { code: '191', title: 'Croatian kuna	 Croatia' },
  HTG: { code: '332', title: 'Haitian gourde	 Haiti' },
  HUF: { code: '348', title: 'Hungarian forint	 Hungary' },
  IDR: { code: '360', title: 'Indonesian rupiah	 Indonesia' },
  ILS: { code: '376', title: 'Israeli new shekel	 Israel' },
  INR: { code: '356', title: 'Indian rupee	 India,  Bhutan' },
  IQD: { code: '368', title: 'Iraqi dinar	 Iraq' },
  IRR: { code: '364', title: 'Iranian rial	 Iran' },
  ISK: { code: '352', title: 'Icelandic króna	 Iceland' },
  JMD: { code: '388', title: 'Jamaican dollar	 Jamaica' },
  JOD: { code: '400', title: 'Jordanian dinar	 Jordan' },
  JPY: { code: '392', title: 'Japanese yen	 Japan' },
  KES: { code: '404', title: 'Kenyan shilling	 Kenya' },
  KGS: { code: '417', title: 'Kyrgyzstani som	 Kyrgyzstan' },
  KHR: { code: '116', title: 'Cambodian riel	 Cambodia' },
  KMF: { code: '174', title: 'Comoro franc	 Comoros' },
  KPW: { code: '408', title: 'North Korean won	 North Korea' },
  KRW: { code: '410', title: 'South Korean won	 South Korea' },
  KWD: { code: '414', title: 'Kuwaiti dinar	 Kuwait' },
  KYD: { code: '136', title: 'Cayman Islands dollar	 Cayman Islands' },
  KZT: { code: '398', title: 'Kazakhstani tenge	 Kazakhstan' },
  LAK: { code: '418', title: 'Lao kip	 Laos' },
  LBP: { code: '422', title: 'Lebanese pound	 Lebanon' },
  LKR: { code: '144', title: 'Sri Lankan rupee	 Sri Lanka' },
  LRD: { code: '430', title: 'Liberian dollar	 Liberia' },
  LSL: { code: '426', title: 'Lesotho loti	 Lesotho' },
  LYD: { code: '434', title: 'Libyan dinar	 Libya' },
  MAD: { code: '504', title: 'Moroccan dirham	 Morocco' },
  MDL: { code: '498', title: 'Moldovan leu	 Moldova' },
  MGA: { code: '969', title: '[11]	Malagasy ariary	 Madagascar' },
  MKD: { code: '807', title: 'Macedonian denar	 Macedonia' },
  MMK: { code: '104', title: 'Myanmar kyat	 Myanmar' },
  MNT: { code: '496', title: 'Mongolian tögrög	 Mongolia' },
  MOP: { code: '446', title: 'Macanese pataca	 Macao' },
  MRU: { code: '12]', title: '9	1*[11]	Mauritanian ouguiya	 Mauritania' },
  MUR: { code: '480', title: 'Mauritian rupee	 Mauritius' },
  MVR: { code: '462', title: 'Maldivian rufiyaa	 Maldives' },
  MWK: { code: '454', title: 'Malawian kwacha	 Malawi' },
  MXN: { code: '484', title: 'Mexican peso	 Mexico' },
  MXV: {
    code: '979',
    title: 'Mexican Unidad de Inversion (UDI) (funds code)	 Mexico',
  },
  MYR: { code: '458', title: 'Malaysian ringgit	 Malaysia' },
  MZN: { code: '943', title: 'Mozambican metical	 Mozambique' },
  NAD: { code: '516', title: 'Namibian dollar	 Namibia' },
  NGN: { code: '566', title: 'Nigerian naira	 Nigeria' },
  NIO: { code: '558', title: 'Nicaraguan córdoba	 Nicaragua' },
  NOK: {
    code: '578',
    title:
      'Norwegian krone	 Norway,  Svalbard and  Jan Mayen (SJ),  Bouvet Island (BV)',
  },
  NPR: { code: '524', title: 'Nepalese rupee	   Nepal' },
  NZD: {
    code: '554',
    title:
      'New Zealand dollar	 New Zealand,  Cook Islands (CK),  Niue (NU),  Pitcairn Islands (PN; see also Pitcairn Islands dollar),  Tokelau (TK)',
  },
  OMR: { code: '512', title: 'Omani rial	 Oman' },
  PAB: { code: '590', title: 'Panamanian balboa	 Panama' },
  PEN: { code: '604', title: 'Peruvian Sol	 Peru' },
  PGK: { code: '598', title: 'Papua New Guinean kina	 Papua New Guinea' },
  PHP: { code: '608', title: 'Philippine piso[13]	 Philippines' },
  PKR: { code: '586', title: 'Pakistani rupee	 Pakistan' },
  PLN: { code: '985', title: 'Polish złoty	 Poland' },
  PYG: { code: '600', title: 'Paraguayan guaraní	 Paraguay' },
  QAR: { code: '634', title: 'Qatari riyal	 Qatar' },
  RON: { code: '946', title: 'Romanian leu	 Romania' },
  RSD: { code: '941', title: 'Serbian dinar	 Serbia' },
  RUB: { code: '643', title: 'Russian ruble	 Russia' },
  RWF: { code: '646', title: 'Rwandan franc	 Rwanda' },
  SAR: { code: '682', title: 'Saudi riyal	 Saudi Arabia' },
  SBD: { code: '090', title: 'Solomon Islands dollar	 Solomon Islands' },
  SCR: { code: '690', title: 'Seychelles rupee	 Seychelles' },
  SDG: { code: '938', title: 'Sudanese pound	 Sudan' },
  SEK: { code: '752', title: 'Swedish krona/kronor	 Sweden' },
  SGD: { code: '702', title: 'Singapore dollar	 Singapore' },
  SHP: {
    code: '654',
    title:
      'Saint Helena pound	 Saint Helena (SH-SH),  Ascension Island (SH-AC),  Tristan da Cunha',
  },
  SLL: { code: '694', title: 'Sierra Leonean leone	 Sierra Leone' },
  SOS: { code: '706', title: 'Somali shilling	 Somalia' },
  SRD: { code: '968', title: 'Surinamese dollar	 Suriname' },
  SSP: { code: '728', title: 'South Sudanese pound	 South Sudan' },
  STN: {
    code: '14]',
    title: '0	2	São Tomé and Príncipe dobra	 São Tomé and Príncipe',
  },
  SVC: { code: '222', title: 'Salvadoran colón	 El Salvador' },
  SYP: { code: '760', title: 'Syrian pound	 Syria' },
  SZL: { code: '748', title: 'Swazi lilangeni	 Swaziland' },
  THB: { code: '764', title: 'Thai baht	 Thailand' },
  TJS: { code: '972', title: 'Tajikistani somoni	 Tajikistan' },
  TMT: { code: '934', title: 'Turkmenistan manat	 Turkmenistan' },
  TND: { code: '788', title: 'Tunisian dinar	 Tunisia' },
  TOP: { code: '776', title: 'Tongan paʻanga	 Tonga' },
  TRY: { code: '949', title: 'Turkish lira	 Turkey' },
  TTD: { code: '780', title: 'Trinidad and Tobago dollar	 Trinidad and Tobago' },
  TWD: { code: '901', title: 'New Taiwan dollar	 Taiwan' },
  TZS: { code: '834', title: 'Tanzanian shilling	 Tanzania' },
  UAH: { code: '980', title: 'Ukrainian hryvnia	 Ukraine' },
  UGX: { code: '800', title: 'Ugandan shilling	 Uganda' },
  USD: {
    code: '840',
    title:
      'United States dollar	 United States,  American Samoa (AS),  Barbados (BB) (as well as Barbados Dollar),  Bermuda (BM) (as well as Bermudian Dollar),  British Indian Ocean Territory (IO) (also uses GBP),  British Virgin Islands (VG),  Caribbean Netherlands (BQ - Bonaire, Sint Eustatius and Saba),  Ecuador (EC),  El Salvador (SV),  Guam (GU),  Haiti (HT),  Marshall Islands (MH),  Federated States of Micronesia (FM),  Northern Mariana Islands (MP),  Palau (PW),  Panama (PA) (as well as Panamanian Balboa),  Puerto Rico (PR),  Timor-Leste (TL),  Turks and Caicos Islands (TC),  U.S. Virgin Islands (VI),  United States Minor Outlying Islands',
  },
  USN: {
    code: '997',
    title: 'United States dollar (next day) (funds code)	 United States',
  },
  UYI: {
    code: '940',
    title: 'Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)	 Uruguay',
  },
  UYU: { code: '858', title: 'Uruguayan peso	 Uruguay' },
  UZS: { code: '860', title: 'Uzbekistan som	 Uzbekistan' },
  VEF: { code: '937', title: 'Venezuelan bolívar	 Venezuela' },
  VND: { code: '704', title: 'Vietnamese đồng	 Vietnam' },
  VUV: { code: '548', title: 'Vanuatu vatu	 Vanuatu' },
  WST: { code: '882', title: 'Samoan tala	 Samoa' },
  XAF: {
    code: '950',
    title:
      'CFA franc BEAC	 Cameroon (CM),  Central African Republic (CF),  Republic of the Congo (CG),  Chad (TD),  Equatorial Guinea (GQ),  Gabon (GA)',
  },
  XAG: { code: '961', title: 'Silver (one troy ounce)' },
  XAU: { code: '959', title: 'Gold (one troy ounce)' },
  XBA: {
    code: '955',
    title: 'European Composite Unit (EURCO) (bond market unit)',
  },
  XBB: {
    code: '956',
    title: 'European Monetary Unit (E.M.U.-6) (bond market unit)',
  },
  XBC: {
    code: '957',
    title: 'European Unit of Account 9 (E.U.A.-9) (bond market unit)',
  },
  XBD: {
    code: '958',
    title: 'European Unit of Account 17 (E.U.A.-17) (bond market unit)',
  },
  XCD: {
    code: '951',
    title:
      'East Caribbean dollar	 Anguilla (AI),  Antigua and Barbuda (AG),  Dominica (DM),  Grenada (GD),  Montserrat (MS),  Saint Kitts and Nevis (KN),  Saint Lucia (LC),  Saint Vincent and the Grenadines (VC)',
  },
  XDR: {
    code: '960',
    title: 'Special drawing rights	International Monetary Fund',
  },
  XOF: {
    code: '952',
    title:
      "CFA franc BCEAO	 Benin (BJ),  Burkina Faso (BF),  Côte d'Ivoire (CI),  Guinea-Bissau (GW),  Mali (ML),  Niger (NE),  Senegal (SN),  Togo (TG)",
  },
  XPD: { code: '964', title: 'Palladium (one troy ounce)' },
  XPF: {
    code: '953',
    title:
      'CFP franc (franc Pacifique)	French territories of the Pacific Ocean:  French Polynesia (PF),  New Caledonia (NC),  Wallis and Futuna (WF)',
  },
  XPT: { code: '962', title: 'Platinum (one troy ounce)' },
  XSU: {
    code: '994',
    title: 'SUCRE	Unified System for Regional Compensation (SUCRE)[15]',
  },
  XTS: { code: '963', title: 'Code reserved for testing purposes' },
  XUA: {
    code: '965',
    title: 'ADB Unit of Account	African Development Bank[16]',
  },
  XXX: { code: '999', title: 'No currency' },
  YER: { code: '886', title: 'Yemeni rial	 Yemen' },
  ZAR: { code: '710', title: 'South African rand	 South Africa' },
  ZMW: { code: '967', title: 'Zambian kwacha	 Zambia' },
  ZWL: { code: '932', title: 'Zimbabwean dollar A/10	 Zimbabwe' },
};
